/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScenarioAlertedPersonCategory } from './InternalApiScenarioAlertedPersonCategory';
import {
    InternalApiScenarioAlertedPersonCategoryFromJSON,
    InternalApiScenarioAlertedPersonCategoryFromJSONTyped,
    InternalApiScenarioAlertedPersonCategoryToJSON,
    InternalApiScenarioAlertedPersonCategoryToJSONTyped,
} from './InternalApiScenarioAlertedPersonCategory';
import type { InternalApiScenarioTypeV2 } from './InternalApiScenarioTypeV2';
import {
    InternalApiScenarioTypeV2FromJSON,
    InternalApiScenarioTypeV2FromJSONTyped,
    InternalApiScenarioTypeV2ToJSON,
    InternalApiScenarioTypeV2ToJSONTyped,
} from './InternalApiScenarioTypeV2';
import type { InternalApiScenarioEntityType } from './InternalApiScenarioEntityType';
import {
    InternalApiScenarioEntityTypeFromJSON,
    InternalApiScenarioEntityTypeFromJSONTyped,
    InternalApiScenarioEntityTypeToJSON,
    InternalApiScenarioEntityTypeToJSONTyped,
} from './InternalApiScenarioEntityType';

/**
 * 
 * @export
 * @interface InternalApiCreateScenario
 */
export interface InternalApiCreateScenario {
    /**
     * 
     * @type {string}
     * @memberof InternalApiCreateScenario
     */
    internalId: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCreateScenario
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCreateScenario
     */
    categoryId: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCreateScenario
     */
    typologyId?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCreateScenario
     */
    libraryScenarioHandle?: string;
    /**
     * 
     * @type {InternalApiScenarioTypeV2}
     * @memberof InternalApiCreateScenario
     */
    type: InternalApiScenarioTypeV2;
    /**
     * 
     * @type {InternalApiScenarioEntityType}
     * @memberof InternalApiCreateScenario
     */
    entityType: InternalApiScenarioEntityType;
    /**
     * 
     * @type {InternalApiScenarioAlertedPersonCategory}
     * @memberof InternalApiCreateScenario
     */
    alertedPersonCategory: InternalApiScenarioAlertedPersonCategory;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiCreateScenario
     */
    includeRelatedTransactions?: boolean;
}



/**
 * Check if a given object implements the InternalApiCreateScenario interface.
 */
export function instanceOfInternalApiCreateScenario(value: object): value is InternalApiCreateScenario {
    if (!('internalId' in value) || value['internalId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('categoryId' in value) || value['categoryId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    if (!('alertedPersonCategory' in value) || value['alertedPersonCategory'] === undefined) return false;
    return true;
}

export function InternalApiCreateScenarioFromJSON(json: any): InternalApiCreateScenario {
    return InternalApiCreateScenarioFromJSONTyped(json, false);
}

export function InternalApiCreateScenarioFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCreateScenario {
    if (json == null) {
        return json;
    }
    return {
        
        'internalId': json['internalId'],
        'name': json['name'],
        'categoryId': json['categoryId'],
        'typologyId': json['typologyId'] == null ? undefined : json['typologyId'],
        'libraryScenarioHandle': json['libraryScenarioHandle'] == null ? undefined : json['libraryScenarioHandle'],
        'type': InternalApiScenarioTypeV2FromJSON(json['type']),
        'entityType': InternalApiScenarioEntityTypeFromJSON(json['entityType']),
        'alertedPersonCategory': InternalApiScenarioAlertedPersonCategoryFromJSON(json['alertedPersonCategory']),
        'includeRelatedTransactions': json['includeRelatedTransactions'] == null ? undefined : json['includeRelatedTransactions'],
    };
}

export function InternalApiCreateScenarioToJSON(json: any): InternalApiCreateScenario {
    return InternalApiCreateScenarioToJSONTyped(json, false);
}

export function InternalApiCreateScenarioToJSONTyped(value?: InternalApiCreateScenario | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'internalId': value['internalId'],
        'name': value['name'],
        'categoryId': value['categoryId'],
        'typologyId': value['typologyId'],
        'libraryScenarioHandle': value['libraryScenarioHandle'],
        'type': InternalApiScenarioTypeV2ToJSON(value['type']),
        'entityType': InternalApiScenarioEntityTypeToJSON(value['entityType']),
        'alertedPersonCategory': InternalApiScenarioAlertedPersonCategoryToJSON(value['alertedPersonCategory']),
        'includeRelatedTransactions': value['includeRelatedTransactions'],
    };
}

